import './BetbookTopEventsFilter.less';

import clsx from 'clsx';
import React from 'react';
import PopupNg from '@/ui/PopupNg';
import i18n from 'nike-ui/src/common/i18n';
import { useReframe } from 'nike-re-framejs';

import Button from '@/common/component/Button';
import ArrowDownIcon from '@/icons/ArrowDownIcon';

import { TIME_TODAY, TIME_TOMORROW } from 'nike-ui/src/components/betbook/constants';
import { topEventsFilterByDate$, topEventsFilterBySport$ } from 'nike-ui/src/components/betbook/subs';
import { SportIconNui } from 'nike-ui/src/icons/SportIconNui';
import { getSportNameById } from 'nike-ui/src/common/utils/utils';

function getButtonDateTitle(byDate) {
    if (!byDate) return i18n('betbook.dropdown.ANYTIME');
    if (byDate === TIME_TODAY) return i18n('betbook.dropdown.TODAY');
    if (byDate === TIME_TOMORROW) return i18n('betbook.dropdown.TOMORROW');
}

function openFilterDialog(e) {
    const dialogOpenKey = e.currentTarget.value;
    PopupNg.dispatcher.open('betbook/postsDialog', { dialogOpenKey });
}

function BetbookTopEventsFilter() {
    const { subscribe } = useReframe();
    const byDate = subscribe(topEventsFilterByDate$);
    const bySportId = subscribe(topEventsFilterBySport$);

    return (
        <div className="flex justify-start pl-10 mb-20 filter-top-events-wrap">
            <div className="default-sub-slider hide-mz-scrollbar betbook-slider-no-bg flex justify-start-left items-center">
                <Button
                    className={clsx('betbook-dropdown-button br-default ', { active: byDate })}
                    onClick={openFilterDialog}
                    value="topEventsByDateDialog"
                >
                    {getButtonDateTitle(byDate)}
                    <div className="arrow-down">
                        <ArrowDownIcon />
                    </div>
                </Button>

                <Button
                    className={clsx('betbook-dropdown-button br-default ', { active: bySportId })}
                    onClick={openFilterDialog}
                    value="topEventsBySportDialog"
                >
                    <div className="flex-center">
                        {bySportId && (
                            <SportIconNui sportId={bySportId} className={clsx('mr-5', { 'c-white': bySportId })} />
                        )}
                        <span className="capitalize-first">
                            {bySportId ? getSportNameById(bySportId) : i18n('betbook.topEvents.allSports')}
                        </span>
                    </div>
                    <div className="arrow-down">
                        <ArrowDownIcon />
                    </div>
                </Button>
            </div>
        </div>
    );
}

export default BetbookTopEventsFilter;
